export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11475.6ba9d719.jpg";